var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 121,
    viewBox: "0 0 297 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.273 -149.814C263.414 -125.191 299.305 -106.803 292.309 -73.2441C285.244 -39.3483 235.176 -20.5228 211.892 10.3223C188.456 41.3678 190.803 85.4921 156.47 106.706C122.48 127.708 84.8441 111.4 48.5186 111.27C12.1025 111.139 -34.7486 127.646 -57.071 105.94C-79.7223 83.914 -55.5165 40.7285 -57.8291 7.85869C-59.7737 -19.7801 -74.7051 -42.7616 -69.5621 -71.6008C-63.5245 -105.456 -56.114 -143.774 -26.104 -170.039C4.0132 -196.398 46.1309 -198.057 83.8398 -205.861C119.779 -213.299 158.017 -224.931 188.308 -214.414C218.228 -204.027 227.952 -173.326 245.273 -149.814Z",
    stroke: "#00FFC4",
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorGreen);
export default __webpack_public_path__ + "static/media/vector_green.f6dc3409e326e91bf0b2e5a63ca6f4f4.svg";
export { ForwardRef as ReactComponent };